import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { Input } from 'app/components';
import './style.scss';
import { validateMobile } from './validation';

const Mobile = ({ phoneNumber, onPhoneNumberChange, onEnterPress, errors, setErrors }) => {
  const inputRef = useRef(null);

  const { activeRequests } = useSelector((state) => state.app);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      onEnterPress();
    }
  };
  const handleMobileChange = (e) => {
    const mobileNumber = e.target.value.replace(/\D/g, '').slice(0,10);
    // Update form data with the new mobile number and clear any error message
    onPhoneNumberChange(mobileNumber);
    setErrors({ ...errors, mobileError: '' });
  };

  const handleMobileBlur = () => {
    const isValid = validateMobile(phoneNumber);
    if(phoneNumber){
      setErrors({ ...errors, mobileError: isValid ? '' : 'Please enter a valid mobile number' });
    }
  };

  return (
    <div className="mobile">
      <div className="heading-36">
        Add your phone number for another layer of security
      </div>
      <div className="text-16">
        We’ll send a One time password (OTP) to this number.
      </div>
      <Input
        ref={inputRef}
        value={phoneNumber}
        onChange={handleMobileChange}
        onBlur={handleMobileBlur}
        onKeyDown={handleKeyDown}
        label="Mobile"
        contentLeft={<>+91</>}
        width="100%"
        validationStatus={errors?.mobileError ? 'error' : null} // Set validation status based on the mobileError property
        helpText={errors?.mobileError}
        disabled={activeRequests?.includes('send-otp')}
        className="input"
        required
        autoFocus
      />
    </div>
  );
};
export default Mobile;
